module.exports = __webpack_public_path__ + "img/radboud.95a5ac10.svg";